import _slicedToArray from "/codebuild/output/src2483311815/src/git-codecommit.eu-west-1.amazonaws.com/v1/repos/sfx_itransfer_agent_portal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React__default, { useState, useEffect, useMemo } from 'react';
import { ProgressBar, ProgressBarColorTypes } from './ProgressBar.js';
import { useVoicePlayer } from '../VoicePlayer/useVoicePlayer.js';
import { PlaybackTime } from './PlaybackTime.js';
import Loader from './Loader.js';
import Icon, { IconTypes, IconColors } from './Icon.js';
import { a as LabelTypography, b as LabelColors } from '../index-6420013c.js';
import { a as VOICE_PLAYER_STATUS } from '../index-fa5b2b8c.js';
import '../consts-fa6ab3c0.js';
import '../VoiceRecorder/context.js';
import '../LocalizationContext-a82461b5.js';
import '../stringSet-b60e9529.js';
import '../index-6add7940.js';
import './Modal.js';
import 'react-dom';
import '../index-a9101009.js';
import './Button.js';
import 'prop-types';
import './IconButton.js';
import '../_rollupPluginBabelHelpers-05128ded.js';
import '../MediaQueryContext-d6110905.js';
import '../useSendbirdStateContext.js';
import '../withSendbird.js';
var VoiceMessageItemBody = function VoiceMessageItemBody(_ref) {
  var _message$reactions2;
  var className = _ref.className,
    message = _ref.message,
    channelUrl = _ref.channelUrl,
    _ref$isByMe = _ref.isByMe,
    isByMe = _ref$isByMe === void 0 ? false : _ref$isByMe,
    _ref$isReactionEnable = _ref.isReactionEnabled,
    isReactionEnabled = _ref$isReactionEnable === void 0 ? false : _ref$isReactionEnable;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    usingReaction = _useState2[0],
    setUsingReaction = _useState2[1];
  var _useVoicePlayer = useVoicePlayer({
      channelUrl: channelUrl,
      key: "".concat(message === null || message === void 0 ? void 0 : message.messageId),
      audioFileUrl: message === null || message === void 0 ? void 0 : message.url
    }),
    play = _useVoicePlayer.play,
    pause = _useVoicePlayer.pause,
    _useVoicePlayer$playb = _useVoicePlayer.playbackTime,
    playbackTime = _useVoicePlayer$playb === void 0 ? 0 : _useVoicePlayer$playb,
    duration = _useVoicePlayer.duration,
    _useVoicePlayer$playi = _useVoicePlayer.playingStatus,
    playingStatus = _useVoicePlayer$playi === void 0 ? VOICE_PLAYER_STATUS.IDLE : _useVoicePlayer$playi;
  useEffect(function () {
    var _message$reactions;
    if (isReactionEnabled && (message === null || message === void 0 ? void 0 : (_message$reactions = message.reactions) === null || _message$reactions === void 0 ? void 0 : _message$reactions.length) > 0) {
      setUsingReaction(true);
    } else {
      setUsingReaction(false);
    }
  }, [isReactionEnabled, message === null || message === void 0 ? void 0 : (_message$reactions2 = message.reactions) === null || _message$reactions2 === void 0 ? void 0 : _message$reactions2.length]);
  var progresBarMaxSize = useMemo(function () {
    if (message !== null && message !== void 0 && message.metaArrays) {
      var _message$metaArrays$f;
      var _duration = message === null || message === void 0 ? void 0 : (_message$metaArrays$f = message.metaArrays.find(function (metaArray) {
        return metaArray.key === 'KEY_VOICE_MESSAGE_DURATION';
      })) === null || _message$metaArrays$f === void 0 ? void 0 : _message$metaArrays$f.value[0];
      return _duration && parseInt(_duration);
    }
    return 1;
  }, [message === null || message === void 0 ? void 0 : message.metaArrays]);
  return /*#__PURE__*/React__default.createElement("div", {
    className: "sendbird-voice-message-item-body ".concat(className, " ").concat(usingReaction ? 'is-reactions-contained' : '')
  }, /*#__PURE__*/React__default.createElement(ProgressBar, {
    className: "sendbird-voice-message-item-body__progress-bar",
    maxSize: duration || progresBarMaxSize,
    currentSize: playbackTime,
    colorType: isByMe ? ProgressBarColorTypes.PRIMARY : ProgressBarColorTypes.GRAY
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "sendbird-voice-message-item-body__status-button"
  }, (playingStatus === VOICE_PLAYER_STATUS.IDLE || playingStatus === VOICE_PLAYER_STATUS.PAUSED) && /*#__PURE__*/React__default.createElement("div", {
    className: "sendbird-voice-message-item-body__status-button__button",
    onClick: play
  }, /*#__PURE__*/React__default.createElement(Icon, {
    width: "18px",
    height: "18px",
    type: IconTypes.PLAY,
    fillColor: IconColors.PRIMARY
  })), playingStatus === VOICE_PLAYER_STATUS.PREPARING && /*#__PURE__*/React__default.createElement(Loader, {
    width: "22.2px",
    height: "22.2px"
  }, /*#__PURE__*/React__default.createElement(Icon, {
    width: "22.2px",
    height: "22.2px",
    type: IconTypes.SPINNER,
    fillColor: IconColors.PRIMARY_2
  })), playingStatus === VOICE_PLAYER_STATUS.PLAYING && /*#__PURE__*/React__default.createElement("div", {
    className: "sendbird-voice-message-item-body__status-button__button",
    onClick: function onClick() {
      pause();
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "sendbird-voice-message-item-body__status-button__button__pause"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "sendbird-voice-message-item-body__status-button__button__pause__inner"
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "sendbird-voice-message-item-body__status-button__button__pause__inner"
  })))), /*#__PURE__*/React__default.createElement(PlaybackTime, {
    className: "sendbird-voice-message-item-body__playback-time",
    time: progresBarMaxSize - playbackTime,
    labelType: LabelTypography.BODY_1,
    labelColor: isByMe ? LabelColors.ONCONTENT_1 : LabelColors.ONBACKGROUND_1
  }));
};
export { VoiceMessageItemBody, VoiceMessageItemBody as default };